export default __webpack_public_path__ + "static/media/Scissors.682fb888.png";